import React from 'react';
import { Box, Card } from '@mui/material';
import { SignInForm } from './SignInForm';

export default function SignInPage() {
    const authStrings = {
        signInHeader: "Sign in",
        signInSubtitle: "Use your CandidateTools account",
        emailLabel: "Email",
        passwordLabel: "Password",
        forgotPassword: "Forgot password?",
        nextButton: "Next",
        switchToSignUp: "Create account",
    };

    return (
        <Card sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', p: 2 }}>
            <SignInForm strings={authStrings} />
        </Card>
    );
}